import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { computed, ref, PropType, Ref, watch, nextTick } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { upsertQaa } from '@/api/operation'
import { ElInput } from 'element-plus'
import { ElMessage, ElMessageBox } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import useFormRules from '@/hooks/useFormRules'
import SelectOperator from '@/components/SelectOperator.vue'
import { useStore } from 'vuex'
import FormRulesFactory from '@/common/formRules'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'QAAUpsert',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  faqInfo: {
    type: Object as PropType<Record<string, any>>,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const qaFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['qaa.operatorID', 'qaa.lang'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(['qaa.q', 'qaa.a'], 'inputEmpty', 'inputInvalid', {
    min: 2,
    max: 800,
  }),
})

const { getters } = useStore()

const { langOptions } = useProtocolEnums()
const { t } = useI18n()





const createRawFormData = () => ({ qaa: {} })

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())
const { createLetterStartRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}
const handleOpenDialog = () => {
  nextTick(() => {
    // 清空校验
    formCom.value.clearValidate()
  })
}
const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const dialogTitle = computed(() => {
  return `${t('Base.edit')}`
})

const submit = async () => {
  try {
    await formCom.value.validate()
    if (
      !getters.isSuperAdmin &&
      !props.isEdit &&
      (formData.value.qaa.operatorID == '' || formData.value.qaa.operatorID == '0')
    ) {
      ElMessage.warning(t(`Base.missingOperator`))
      return
    }
    isSubmitting.value = true
    await upsertQaa(formData.value)
    if (props.isEdit) {
      ElMessage.success(t(`Base.updateSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

watch(showDialog, async (val) => {
  if (props.isEdit) {
    formData.value.qaa = { ...props.faqInfo }
  } else {
    formData.value.qaa = createRawFormData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "50%",
    class: "upsert-dialog",
    title: _unref(dialogTitle),
    "z-index": 2000,
    onOpen: handleOpenDialog
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: qaFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "qaa.operatorID",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: formData.value.qaa.operatorID,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.qaa.operatorID) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.language'),
                    prop: "qaa.lang",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.qaa.lang,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.qaa.lang) = $event)),
                        prop: "qaa.lang"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langOptions), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.q'),
                    prop: "qaa.q",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        type: "textarea",
                        modelValue: formData.value.qaa.q,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.qaa.q) = $event)),
                        rows: 3
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Base.a'),
                    prop: "qaa.a",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElInput), {
                        type: "textarea",
                        modelValue: formData.value.qaa.a,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.qaa.a) = $event)),
                        rows: 3
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})